import type { MeetingMinute } from '../types/crm';
import { minuteAttendees, minuteDiscussion } from './meetingMinutesHelpers';
import { formatSingaporeDate } from '../utils/dateTime';

export function projectTitleFromMinute(minute: MeetingMinute): string {
  const base = minute.title.trim() || 'Meeting follow-up';
  return base.toLowerCase().startsWith('follow-up') ? base : `Follow-up: ${base}`;
}

export function taskTitleFromMinute(minute: MeetingMinute): string {
  return minute.title.trim() || 'Follow-up from meeting';
}

export function taskDescriptionFromMinute(minute: MeetingMinute): string {
  const when = minute.meeting_date ? formatSingaporeDate(minute.meeting_date) : '—';
  const parts = [`From meeting minutes (${when})`, ''];

  const attendees = minuteAttendees(minute);
  if (attendees) {
    parts.push('Attendees:', attendees, '');
  }

  const discussion = minuteDiscussion(minute);
  parts.push('Discussion:', discussion || '(no discussion recorded)');

  return parts.join('\n').slice(0, 4000);
}
